import { render, staticRenderFns } from "./receiveMethodsList.vue?vue&type=template&id=34785686&"
import script from "./receiveMethodsList.vue?vue&type=script&lang=js&"
export * from "./receiveMethodsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports